// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Linkify from 'react-linkify';

// Modules
import ShowOrganizerLogo from 'components/SharedComponents/logo/showOrganizerLogo';
import ShowAddOrganizerLogo from 'components/SharedComponents/logo/ShowAddOrganizerLogo';
import ShowLogo from 'components/SharedComponents/logo/showLogo';
import InlineEdit from 'components/SharedComponents/Inline/inline-edit';
import { SocialShare } from 'components/SharedComponents/social-share';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import { ChannelPrivacy } from 'components/catalog/privacy-setting/channel-privacy';

// Strings
const classPrefix = 'channel-info';

export class ChannelInfo extends React.Component {
    constructor(props) {
        super(props);
    }

// ------------------------------------------- CHANNEL TITLE ------------------------------------------------
    displayChannelInfoTitle() {
        if (!this.props.title) { return this.showSpinner(); }
        if (!this.props.isChannelOwner) { return (<div className={`${classPrefix}_title`}>{this.props.title}</div>); }

        return (
            <span className={`${classPrefix}_title`} >
                <InlineEdit
                  maxlength={25}
                  t={this.props.t}
                  editText={this.dataChanged.bind(this)}
                  text={this.props.title}
                  id="inline-edit-title"
                  characterCheckRequired={true}
                  regex={/\[|\]|\{|\}+/}
                />
            </span>
        );
    }

    dataChanged(id, data) {
        this.setState({titleShowCharacterCount: false});
        this.props.onChannelTitleChange(id, data);
    }

    showSpinner() {
        return (
            <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
        );
    }

// ------------------------------------------- CHANNEL DESCRIPTION ------------------------------------------------
    displayChannelDescription() {
        if (!this.props.isChannelOwner) {
            return (this.props.description) ? (
                <Linkify properties={{target: '_blank', rel: 'nofollow' }}><span className={`${classPrefix}_description`}>{this.props.description}</span></Linkify>) : null;
        }
        const {t} = this.props;

        return (
            <span className={`${classPrefix}_description`}>
                <InlineEdit
                  maxlength={500}
                  minLength={0}
                  t={this.props.t}
                  editText={this.descriptionChanged.bind(this)}
                  text={this.props.description ? this.props.description : ''}
                  id="inline-edit-description"
                  editingElement="textArea"
                  placeholder={t('channel.info.addChannelDescription')}
                  regex={/\[|\]|\{|\}+/}
                  characterCheckRequired={true}
                />
            </span>
        );
    }

    descriptionChanged(id, data) {
        this.setState({descShowCharacterCount: false});
        this.props.onChannelDescriptionChange(data);
    }
// ------------------------------------------- CHANNEL LOGO ------------------------------------------------

    displayChannelInfoLogo() {
        const {t} = this.props;
        if (this.props.isChannelOwner) {
            if (this.props.logo) {
                return (
                    <div className={`${classPrefix}-logo`}>
                        <ShowOrganizerLogo
                          channelLogo={this.props.logo}
                          onClick={this.props.onLogoDeleteClick}
                        />
                    </div>
                );
            }
            return (
                <div className={`${classPrefix}-logo`}>
                    <ShowAddOrganizerLogo
                      onClick={this.props.onLogoAddClick}
                      description={t('SharedComponents.tooltip-channel-logo.description')}
                      ok={t('SharedComponents.tooltip-channel-logo.ok')}
                      okBtn={this.props.okBtn}
                    />
                </div>
            );
        }
        return (this.props.logo) ? <div className={`${classPrefix}-logo`}><ShowLogo channelLogo={this.props.logo} /></div> : null;
    }

// ------------------------------------------- SOCIAL SHARE ------------------------------------------------

    renderSocialShare(facebook = true, linkedin = true, twitter = true) {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-content-share`}>
                <span className={`${classPrefix}-share_title`}>{t('SharedComponents.share-component')}</span>
                <SocialShare
                  title={this.props.title}
                  description={this.props.description}
                  linkValue={this.props.linkValue}
                  metaImage={this.props.logo}
                  t={t}
                  page={mixpanelTracker.channelPage}
                  facebook={facebook}
                  linkedIn={linkedin}
                  twitter={twitter}
                />
            </div>
        );
    }


    displayChannelInfoSocialShare() {
        if (!this.props.isLimitedAudience) {
            return this.renderSocialShare();
        } else if (this.props.isLimitedAudience && this.props.isChannelOwner) {
            return this.renderSocialShare(false, false, false);
        }
        return null;
    }

// ------------------------------------------- RENDER ------------------------------------------------
    render() {
        return (
            <div className={`row ${classPrefix}`}>
                <div className="col-md-8 col-xs-12">
                    {this.displayChannelInfoLogo()}
                    <div>
                        <ChannelPrivacy {...this.props} />
                        <div className={`${classPrefix}-title-desc`}>
                            {this.displayChannelInfoTitle()}
                            {this.displayChannelDescription()}
                        </div>
                    </div>
                </div>
                <div className={`col-md-4 col-xs-12 ${classPrefix}-data`}>
                    {this.displayChannelInfoSocialShare()}
                </div>
            </div>
        );
    }
}

ChannelInfo.defaultProps = {
    description: null,
    title: '',
    linkValue: ' ',
    logo: null
};

ChannelInfo.propTypes = {
    t: PropTypes.func,
    logo: PropTypes.string,
    isChannelOwner: PropTypes.bool,
    title: PropTypes.string,
    linkValue: PropTypes.string,
    onChannelTitleChange: PropTypes.func,
    onChannelDescriptionChange: PropTypes.func,
    description: PropTypes.string,
    isLimitedAudience: PropTypes.bool,
    onLogoAddClick: PropTypes.func,
    onLogoDeleteClick: PropTypes.func,
    okBtn: PropTypes.func
};

export default translate(['translation'])(ChannelInfo);



// WEBPACK FOOTER //
// ./src/components/catalog/info/channel-info.js